export const SEARCH_HEDGEFUND = "SEARCHHEDGEFUND@SEARCH_HEDGEFUND";
export const SEARCH_HEDGEFUND_INIT = "SEARCHHEDGEFUND@SEARCH_HEDGEFUND_INIT";
export const SEARCH_HEDGEFUND_SUCCESS = "SEARCHHEDGEFUND@SEARCH_HEDGEFUND_SUCESS";
export const SEARCH_HEDGEFUND_FAILED = "SEARCHHEDGEFUND@SEARCH_HEDGEFUND_FAILED";

export const GET_STRATEGY = "SEARCHHEDGEFUND@STRATEGY";
export const GET_STRATEGY_INIT = "SEARCHHEDGEFUND@STRATEGY_INIT";
export const GET_STRATEGY_SUCCESS = "SEARCHHEDGEFUND@STRATEGY_SUCESS";
export const GET_STRATEGY_FAILED = "SEARCHHEDGEFUND@STRATEGY_FAILED";

export const GET_REGION = "SEARCHHEDGEFUND@REGION";
export const GET_REGION_INIT = "SEARCHHEDGEFUND@REGION_INIT";
export const GET_REGION_SUCCESS = "SEARCHHEDGEFUND@REGION_SUCESS";
export const GET_REGION_FAILED = "SEARCHHEDGEFUND@REGION_FAILED";

export const FOLLOW_FUND = "SEARCHHEDGEFUND@FUND";
export const FOLLOW_FUND_INIT = "SEARCHHEDGEFUND@FUND_INIT";
export const FOLLOW_FUND_SUCCESS = "SEARCHHEDGEFUND@FUND_SUCESS";
export const FOLLOW_FUND_FAILED = "SEARCHHEDGEFUND@FUND_FAILED";

export const GET_SUBSPECIALTY = "SEARCHHEDGEFUND@SUBSPECIALTY";
export const GET_SUBSPECIALTY_INIT = "SEARCHHEDGEFUND@SUBSPECIALTY_INIT";
export const GET_SUBSPECIALTY_SUCCESS = "SEARCHHEDGEFUND@SUBSPECIALTY_SUCESS";
export const GET_SUBSPECIALTY_FAILED = "SEARCHHEDGEFUND@SUBSPECIALTY_FAILED";

export const CREATE_RECOMMENDFUND = "SEARCHHEDGEFUND@CREATE_RECOMMENDFUND";
export const CREATE_RECOMMENDFUND_INIT = "SEARCHHEDGEFUND@CREATE_RECOMMENDFUND_INIT";
export const CREATE_RECOMMENDFUND_SUCCESS = "SEARCHHEDGEFUND@CREATE_RECOMMENDFUND_SUCCESS";
export const CREATE_RECOMMENDFUND_FAILED = "SEARCHHEDGEFUND@CREATE_RECOMMENDFUND_FAILED";